<template>
  <w-list :items="items" nav color="primary">
    <template #item="{ item }">
      <w-icon md>{{ item.icon }}</w-icon>
      <div class="spacer"></div>
      <span class="text-right">{{ item.label }}</span>
    </template>
  </w-list>
</template>

<script>
import { store } from '@/utils/store'
import { ref } from 'vue';
const disbled = window.__env?.defaults?.pagesDisabled || []

export default {
  name: 'MainNavbar',
  components: {

  },
  setup: () => {
    const items = ref([])
    
    if (store.currentUser.roles.includes("ADMIN")) {
      items.value = [
        { label: 'Monitoring Map', icon: 'mdi mdi-radar', route: '/monitoring-map' },
        { label: 'Thing Definition', icon: 'mdi mdi-pencil', route: '/definition-things' },
        { label: 'Thing', icon: 'mdi mdi-robot-excited-outline', route: '/things/All' },
        { label: 'Base Station', icon: 'mdi mdi-video-input-antenna', route: '/AddBaseStation' },
        { label: 'Coverage', icon: 'mdi mdi-signal', route: '/coverage-base-stations' },
        { label: 'Group', icon: 'mdi mdi-tag', route: '/label-group' },
        { label: 'Robots', icon: 'mdi mdi-robot-mower', route: '/robots' },
        { label: 'Users Manager', icon: 'mdi mdi-account', route: '/users-manager' },
      ]
    } else {
      items.value = [
        { label: 'Thing', icon: 'mdi mdi-robot-excited-outline', route: '/things/All' },
        { label: 'Base Station', icon: 'mdi mdi-video-input-antenna', route: '/AddBaseStation' },
        { label: 'Coverage', icon: 'mdi mdi-signal', route: '/coverage-base-stations' },
        { label: 'Robots', icon: 'mdi mdi-tag', route: '/robots' },
        { label: 'Monitoring Map', icon: 'mdi mdi-radar', route: '/monitoring-map' },
      ]
    }
    items.value=items.value.filter(page=>!disbled.includes(page['route']))

    return {
      store,
      items
    }
  }
}
</script>

<style scoped>
</style>

